import GlobalModal from "../../Modal/GlobalModal";

/**
 * @deprecated - Use GlobalModal from /src/components/modal/GlobalModal.jsx
 */
export default GlobalModal;
